import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { ConnectionShape } from '../../../../prop-types'
import * as PropTypes from 'prop-types'
import { connectionOperations } from '../../../../state/ducks/connections'
import { connect } from 'react-redux'
import { Session } from '../../../../state/utils/session'
import { ConnectionDetailsCard, ConnectionTimelineCard } from '../../containers'

class ConnectionDetailsPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.props.getConnection(this.props.match.params.connection_id)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_CONNECTIONS_PATH.replace(':client_id', this.state.session.getClientSession())}
                    >
                        Connections
                    </NavLink>
                </li>
                <li>Connection Details</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={this.props.connection.name}
                        subTitle={'Connection Details'}
                        paths={this.renderHeaderPaths}
                    />
                    <div className="content content-boxed">
                        <div className="row">
                            <div className="col-sm-12 col-lg-5">
                                {/* Details */}
                                <ConnectionDetailsCard connection={this.props.connection}/>
                                {/* END Details */}
                            </div>
                            <div className="col-sm-12 col-lg-7">
                                {/* Timeline */}
                                <ConnectionTimelineCard connection={this.props.connection}/>
                                {/* END Timeline */}
                            </div>
                        </div>
                    </div>
                </PageContainerLayout>
            </>
    )
  }
}

// Set propTypes
ConnectionDetailsPage.propTypes = {
  connection: ConnectionShape,
  getConnectionErrorResponse: PropTypes.object
}

// Set defaultProps
ConnectionDetailsPage.defaultProps = {
  connection: {},
  getConnectionErrorResponse: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  connection: state.connections.getConnectionReducer.data,
  isLoading: state.connections.getConnectionReducer.loading,
  getConnectionErrorResponse: state.connections.getConnectionReducer.error_data
})

// mapStateToProps
const mapDispatchToProps = {
  getConnection: connectionOperations.get
}

// Export Class
const _ConnectionDetailsPage = connect(mapStateToProps, mapDispatchToProps)(ConnectionDetailsPage)
export { _ConnectionDetailsPage as ConnectionDetailsPage }
